// extracted by mini-css-extract-plugin
module.exports = {"accountsPage":"accountsPage__lJcoX","errorAlert":"errorAlert__QqcTX","noDataContent":"noDataContent__Gk90S"};